/**
 * @author vishwadeep.kapoor
 * HeaderContainer actions
 *
 */

import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
// import { createAxiosInstance } from '../../config/services';
import { utils, eventTracking, constants } from '../../devUtils';
import { LOGIN_SUCCESS, LOGIN_ERROR } from '../LoginPage/constants';
import { DEFAULT_ERROR, DEFAULT_ERROR_CLEAR, DEFAULT_ACTION, FETCH_USER_PROFILE_SUCCESS, SET_USER_CITY, SET_SEARCH_TYPE, SET_USER_PROFILE_LOGOUT,
  SET_WINDOW_SCREENCHANGE, SET_EVOUCHER_OTP } from './constants';
import { LINK_THANKYOU } from '../../devUtils/constants';

/**
 * @todo: move to utils
 * @func rootApiResponse
 * @arg payload
 *      @example { api: <API_TYPE>, reason: <RESPONSE_ERROR>, success: boolean  }
 */
export const rootApiResponse = (payload) => ({ type: DEFAULT_ERROR, payload });
export const clearDefaultError = (payload) => ({ type: DEFAULT_ERROR_CLEAR, payload });
export const fetchProfileSuccess = (payload) => ({ type: FETCH_USER_PROFILE_SUCCESS, payload });
// export const fetchProfileError = (payload) => ({ type: FETCH_USER_PROFILE_ERROR, payload });
export const defaultAction = (payload = true) => ({ type: DEFAULT_ACTION, payload }); // making loading true in root reducer

export const loginSuccess = () => ({ type: LOGIN_SUCCESS });
export const loginError = () => ({ type: LOGIN_ERROR });
/**
 * @desc if used one more time move it to devUtils
 * @param {headers} payload
 * @returns {object}
 */
const getTokenAndDeviceId = (payload) => {
  if (!payload) {
    return;
  }
  const _payload = payload;
  const _payloadAry = _payload ? _payload.split('=') : [];
  const token = _payloadAry.length && _payloadAry[1].split(';')[0];
  const device_id = _payloadAry && _payloadAry.length >= 3 && _payloadAry[3];
  return { token, device_id }; // eslint-disable-line consistent-return
};
const setUserCitySuccess = (payload) => ({ type: SET_USER_CITY, payload });


/**
 * @arg doNot move to the utils for headers as its getting params from after login also
 * @arg api.defaults.headers.Authorization deleating as it goes to @default axios instance
 * @param {object} payload
 * @example isLoaderRequired only from login function
 * @todo: let PATH = endpoint.GET_USER_INFO_LITE; check the SSR layer data fetch with {reqHandler.getHandler(_api, endpoint.GET_USER_INFO_LITE);}
 */
export const fetchUserProfile = (payload = {}, isLoaderRequired) => async (dispatch, getState, api) => {
  let _payload = payload;
  const { token, device_id, client_id } = _payload;
  const _api = { ...api };
  const { token: cookiesToken, device_id: cookiesDeviceId, client_id: cookiesClientId } = await reqHandler.getHandler(api, endpoint.GET_TOKEN);
  try {
    dispatch(defaultAction(isLoaderRequired));
    if (_api.defaults.headers && token && device_id) { // !_api.defaults.headers.Authorization
      _api.defaults.headers.Authorization = utils.addAuthorizationHeaders(token, device_id, client_id);
    } else if (_api.defaults.headers && cookiesToken && cookiesDeviceId) {
      _api.defaults.headers.Authorization = utils.addAuthorizationHeaders(cookiesToken, cookiesDeviceId, cookiesClientId);
      _payload = getTokenAndDeviceId(_api.defaults.headers.Authorization);
    } else {
      _payload = getTokenAndDeviceId(_api.defaults.headers.Authorization);
    }
    const res = await reqHandler.getHandler(_api, endpoint.GET_USER_INFO_LITE);
    delete _api.defaults.headers.Authorization;
    const setPayload = { ..._payload, ...res.user };
    dispatch(fetchProfileSuccess(setPayload));
    dispatch(loginSuccess());
  } catch (err) {
    dispatch(defaultAction(false));
    dispatch(loginError());
  }
};

const getUpdatedUserProfile = (callback) => async (dispatch, getState, api) => {
  try {
    const preuserDetails = utils.immutableToJS(utils.immutableUserDetails(getState));
    dispatch(clearDefaultError());
    // dispatch(defaultAction());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const res = await reqHandler.getHandler(api, endpoint.GET_USER_INFO_LITE, null, authPrerequist);
    const setPayload = { ...preuserDetails, ...res.user, ...res.status };
    dispatch(fetchProfileSuccess(setPayload));
    if (callback) {
      callback();
    }
  } catch (error) {
    // dispatch(defaultAction(false));
  }
};

/**
 * @param {object} payload
 * @return {dispatch}
 */
export const setUserCity = (payload) => async (dispatch, getState, api) => {
  try {
    const { city } = payload;
    const params = { address: city.toLowerCase(), sensor: false };
    const { results } = await reqHandler.getHandler(api, endpoint.GOOGLE_MAP, params);
    if (results && results.length) {
      const { geometry: { location: { lat: latitude, lng: longitude } } } = results[0];
      const setPayload = { ...payload, location: { latitude, longitude } };
      dispatch(setUserCitySuccess(setPayload));
    } else {
      dispatch(setUserCitySuccess(payload)); // incase api not able to give response default
    }
  } catch (err) {
    dispatch(setUserCitySuccess(payload));
    console.log('error in fetching userCity...............', err);
  }
};

/**
 * @param {string} payload
 * @return {dispatch}
 */
export const setSearchChange = (type, value) => ({ type: SET_SEARCH_TYPE, payload: { type, value } });
export const setProfileLogout = () => ({ type: SET_USER_PROFILE_LOGOUT });
export const changeWindowSize = (payload) => ({ type: SET_WINDOW_SCREENCHANGE, payload });

/**
 * @description @function setFooterSubscribe is not connected with the redux-store
 * @callback payload.callback
 * @param {object} payload
 */

const setFooterSubscribe = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const response = await GLOBAL_API_NOTIFICATION(api, payload);
    eventTracking.triggerEvent('Miscellaneous', 'Subscribe', 'Success');
    if (response && response.message) {
      throw (response.message);
    } else {
      dispatch(rootApiResponse(utils.successResponse('setFooterSubscribe', constants.ALERT_SUBSCRIBED_SUCCESS)));
    }
  } catch (err) {
    eventTracking.triggerEvent('Miscellaneous', 'Subscribe', 'Failure');
    dispatch(rootApiResponse(utils.errorResponse('setFooterSubscribe', err)));
  }
};


const SetContactUs = (payload, { ...otherParams } = {}) => async (dispatch, getState, api) => {
  const { history } = otherParams;
  try {
    dispatch(clearDefaultError());
    const response = await reqHandler.postHandler(api, endpoint.POST_DEMO_REGISTER, payload);
    if (response && response.message) {
      utils.forceRedirect(history, { pathname: LINK_THANKYOU });
      return dispatch(rootApiResponse(utils.successResponse('SetContactUs', response.message)));
    }
    throw (response.message);
  } catch (err) {
    return dispatch(rootApiResponse(utils.errorResponse('SetContactUs', err)));
  }
};


/**
 * @description API having multiple usage
 * @param {axios_insatance} api
 * @param {*object} payload
 */
export const GLOBAL_API_NOTIFICATION = (api, payload) => reqHandler.postHandler(api, endpoint.POST_NOTIFICATION, payload);

/**
 * @desc use @func resetPopup when required to show the popup from the UI layer
 * @param alertType added for the case of popup/fullScreen
 */
export const resetPopup = (payload, actionType, alertType) => async (dispatch) => {
  await dispatch(clearDefaultError());
  if (actionType === 'error') {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, payload, alertType)));
  } else {
    dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, payload, alertType)));
  }
};

const SetEvoucherOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_EVOUCHER_OTP, payload, authPrerequist);
    if (response && response.status) {
      dispatch({ type: SET_EVOUCHER_OTP, payload: { ...response, ts: Date.now() } });
      return dispatch(rootApiResponse(utils.successResponse('SetEvoucherOtp', response.message)));
    }
    dispatch({ type: SET_EVOUCHER_OTP, payload: {} });
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse('SetEvoucherOtp', err)));
  }
};

const GET_REQ_HANDLER = (type) => {
  switch (type) {
    case 'GET':
      return reqHandler.getHandler;
    case 'PUT':
      return reqHandler.putHandler;
    case 'DELETE':
      return reqHandler.deleteHandler;
    case 'POST':
      return reqHandler.postHandler;
    default:
      return reqHandler.getHandler;
  }
};

export { GET_REQ_HANDLER, setFooterSubscribe, getUpdatedUserProfile, SetContactUs,
  SetEvoucherOtp };



// WEBPACK FOOTER //
// client/containers/HeaderContainer/actions.js